import TipBox from "../Common/TipBox";
import store from "../Common/Store";
import Panel from "../Common/Panel";
import RoomPlanHeader from "../Common/RoomPlanHeader";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function ModePage() {
  const [state, setState] = useState(1);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    store.empty();
    i18n.changeLanguage(localStorage.getItem("lang"));
  }, [i18n]);

  const choices = [
    {
      id: 1,
      image: "img/shapes.png",
      imageClass: "mode-card__image--shapes",
      title: "Choose room shape",
      description: "Pick from our most common room layouts to get started quickly.",
    },
    {
      id: 2,
      image: "img/room_img.png",
      imageClass: "mode-card__image--custom",
      title: "Create custom shape",
      description:
        "Draw your own room layout to create a plan that fits your space perfectly.",
    },
  ];

  return (
    <div className="mode-page">
      <div className="mode-page__content">
        <RoomPlanHeader
          title="Choose your room plan"
          description="Select a predefined room shape or draw your own to match your space."
        />

        <div className="mode-page__options">
          <div className="mode-page__grid" role="radiogroup">
            {choices.map((choice) => {
              const selected = state === choice.id;

              return (
                <div
                  key={choice.id}
                  className={`mode-card ${
                    selected ? "mode-card--selected" : ""
                  }`}
                  role="radio"
                  tabIndex={0}
                  aria-checked={selected}
                  onClick={() => setState(choice.id)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      setState(choice.id);
                    }
                  }}
                >
                  <div className="mode-card__visual">
                    {choice.id === 1 ? (
                      <div className="mode-card__shape-shortcuts">
                        <img
                          className={`mode-card__image ${choice.imageClass}`}
                          alt=""
                          src={choice.image}
                        />
                        <div className="mode-card__shape-shortcut-grid">
                          {[1, 2, 3].map((shapeId) => (
                            <button
                              key={shapeId}
                              type="button"
                              className="mode-card__shape-shortcut"
                              aria-label={t(
                                ["Rectangle form", "L-shaped", "T-shaped"][
                                  shapeId - 1
                                ]
                              )}
                              onClick={(event) => {
                                event.stopPropagation();
                                navigate(`/standartmode?fig_type=${shapeId}`);
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    ) : (
                      <img
                        className={`mode-card__image ${choice.imageClass}`}
                        alt=""
                        src={choice.image}
                      />
                    )}
                  </div>
                  <span className="mode-card__divider" aria-hidden="true" />
                  <h2>{t(choice.title)}</h2>
                  <p>{t(choice.description)}</p>
                  <span className="room-choice-indicator" aria-hidden="true">
                    {selected ? "✓" : ""}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <TipBox
        tip="1"
        next={state === 1 ? "/selectshape" : "/imgmode"}
        prev={false}
      />
      <Panel page="1" />
    </div>
  );
}

export default ModePage;
